export const recognizedMgItemNrHeadings = [
  'mgitem-number',
  'mg-item-number',
  'mg-item number',
  'mgitem number',
  'mg item number',
  'mgitemnumber',

  'mg-item-nummer',
  'mg-item nummer',
  'mgitem-nummer',
  'mgitem nummer',
  'mg item nummer',
  'mgitemnummer',

  'mgitem-nr',
  'mgitem nr',
  'mgitemnr',
  'mg item nr',
];

export const recognizedGtinHeadings = [
  'gtin',
  'gtinnumber',
  'gtin-number',
  'gtin number',
  'gtincode',
  'gtin-code',
  'gtin code',
  'gtin-kod',
  'gtin kod',
  'gtinkod',
  'gtin-kode',
  'gtinkode',
  'gtin kode',
  'gtin nummer',
  'gtin-nummer',
  'gtinnummer',
  'gtinnr',
  'gtin-nr',
  'gtin-nr',
];

export const recognizedNobbNrHeadings = ['nobbnummer', 'nobbnr'];
export const recognizedFinfoNrHeadings = ['finfonummer', 'finfonr'];

export const recognizedSupplierIdHeadings = [
  'supplierid',
  'supplier-id',
  'supplier id',
  'mgsupplierid',
  'mgsupplier-id',
  'mg-supplier-id',
  'mgsupplier id',
  'mg supplier id',
  'mg supplierid',
  'leverantörs-id',
  'leverantörsid',
  'leverantörs id',
  'leverandør-id',
  'leverandørid',
  'leverandør id',
];

export const recognizedValidFromHeadings = [
  'validfrom',
  'valid from',
  'valid-from',
  'fromdate',
  'from-date',
  'from date',
  'fra-dato',
  'fra dato',
  'från datum',
  'från-datum',
  'gyldig fra',
  'gyldig-fra',
  'giltig från',
  'giltig-från',
];

export const recognizedValidToHeadings = [
  'todate',
  'to-date',
  'to date',
  'validto',
  'valid to',
  'valid-to',
  'til-dato',
  'til dato',
  'till datum',
  'till-datum',
  'gyldig til',
  'gyldig-til',
  'giltig till',
  'giltig-till',
];

export const recognizedGroupNumberHeadings = [
  'groupnumber',
  'productgroup',
  'varugrupp',
  'varegruppe',
];

export const recognizedDiscountGroupHeadings = [
  'groupcode',
  'groupcodes',
  'discountgroup',
  'rabattgrupp',
  'rabattgruppe',
];

export const recognizedSalesFactorHeadings = ['salgsfaktor', 'salesfactor'];

export const recognizedSalesPriceHeadings = ['salgspris', 'salesprice'];

export const recognizedIncMvaHeadings = ['inkmva', 'inkmoms', 'incmva'];

export const recognizedCoverageDegreeHeadings = ['coveragedegree', 'dg', 'tg'];

export const recognizedSubAssortmentsHeadings = [
  'subassortments',
  'subassortment',
  'tagid',
  'tagids',
  'undersortiment',
  'undersortimenter',
  'tag',
  'tags',
];
